// extracted by mini-css-extract-plugin
export default {"file_breadcrumbs":"path_file_breadcrumbs__8Ict+","file_breadcrumbs_text":"path_file_breadcrumbs_text__k8WSG","file_breadcrumbs_link":"path_file_breadcrumbs_link__OkYSC"};